import { render, staticRenderFns } from "./AnalyticCreate.vue?vue&type=template&id=edc6cd8a&scoped=true&"
import script from "./AnalyticCreate.vue?vue&type=script&lang=js&"
export * from "./AnalyticCreate.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticCreate.vue?vue&type=style&index=0&id=edc6cd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc6cd8a",
  null
  
)

export default component.exports